export const Digits = /\d/;
export const UppercaseLetters = /[A-Z]/;
export const LowercaseLetters = /[a-z]/;
export const SpecialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

export const Alphanumerical = /^[a-zA-Z0-9]+$/;
export const Email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
